import styled from 'styled-components';
import { fromMd, hoverSupportMedia, withFinePointer } from '../../constants';
import { HalfDotWrap, InnerDot, OuterDot } from '../ColorSwatch/styles';
import { StyledIcon } from '../Icons/BaseIcon';
import { ScrolledAttributeSelector } from '../ScrolledAttributeSelector';
const smallOuterDotDiameter = '24px';
const smallInnerDotDiameter = '19px';
const largeOuterDotDiameter = '30px';
const largeInnerDotDiameter = '25px';
export const Body = styled(ScrolledAttributeSelector) `
  margin: 0px -${props => props.theme.spacing(1)};
  box-sizing: border-box;

  ${o => (o.disabled ? 'opacity: 0.5;' : null)}

  width: ${props => (props.disableMobileHorizontalSwipe ? '100%' : 'auto')};
  flex-wrap: ${props => (props.disableMobileHorizontalSwipe ? 'wrap' : 'nowrap')};
  ${fromMd}, ${hoverSupportMedia} {
    width: 100%;
    flex-wrap: wrap;
  }

  ${OuterDot} {
    height: ${largeOuterDotDiameter};
    max-width: ${largeOuterDotDiameter};
    min-width: ${largeOuterDotDiameter};

    ${props => props.swatchSpacing === 'small' &&
    `
      height: ${smallOuterDotDiameter};
      max-width: ${smallOuterDotDiameter};
      min-width: ${smallOuterDotDiameter};
    `}

    ${withFinePointer} {
      height: ${smallOuterDotDiameter};
      max-width: ${smallOuterDotDiameter};
      min-width: ${smallOuterDotDiameter};
    }
  }
  ${OuterDot} {
    margin: ${o => o.swatchSpacing === 'small'
    ? `0px 2px`
    : `0px ${o.theme.spacing(1)} ${o.theme.spacing(2)} ${o.theme.spacing(1)}`};
  }

  ${InnerDot}, ${HalfDotWrap}, ${StyledIcon} {
    width: ${largeInnerDotDiameter};
    height: ${largeInnerDotDiameter};

    ${props => props.swatchSpacing === 'small' &&
    `
      height: ${smallInnerDotDiameter};
      width: ${smallInnerDotDiameter};
    `}

    ${withFinePointer} {
      width: ${smallInnerDotDiameter};
      height: ${smallInnerDotDiameter};
    }
  }
`;
//# sourceMappingURL=styles.js.map